import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmationDialogProps {
    title: string;
    open: boolean;
    onClose: (value?: boolean) => void;
    saveButton?: React.ReactNode;
}

const ConfirmationDialog: React.FunctionComponent<ConfirmationDialogProps> = ({ title, open, onClose, children, saveButton }) => {
    const { t } = useTranslation();

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(true);
    };

    return (
        <Dialog open={open} maxWidth="xs">
            <DialogTitle>{t(title)}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    {t("cancel")}
                </Button>
                {saveButton ? <>{saveButton}</> : <Button onClick={handleOk}>Ok</Button>}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
